import React from 'react';

const MoneyIconV2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.6673 4H19.334C19.8644 4 20.3731 4.21071 20.7482 4.58579C21.1233 4.96086 21.334 5.46957 21.334 6C21.334 7.23768 20.8423 8.42466 19.9671 9.29983C19.092 10.175 17.905 10.6667 16.6673 10.6667H15.334C14.0963 10.6667 12.9093 10.175 12.0342 9.29983C11.159 8.42466 10.6673 7.23768 10.6673 6C10.6673 5.46957 10.878 4.96086 11.2531 4.58579C11.6282 4.21071 12.1369 4 12.6673 4Z",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.33398 22.6667V21.3333C5.33398 18.5044 6.45779 15.7912 8.45818 13.7909C10.4586 11.7905 13.1717 10.6667 16.0007 10.6667C18.8296 10.6667 21.5427 11.7905 23.5431 13.7909C25.5435 15.7912 26.6673 18.5044 26.6673 21.3333V22.6667C26.6673 24.0812 26.1054 25.4377 25.1052 26.4379C24.105 27.4381 22.7485 28 21.334 28H10.6673C9.25283 28 7.89628 27.4381 6.89608 26.4379C5.89589 25.4377 5.33398 24.0812 5.33398 22.6667Z",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
MoneyIconV2.displayName = "Icons.MoneyIconV2";

export { MoneyIconV2 };
//# sourceMappingURL=MoneyIconV2.js.map
